import { Step } from '../components/steps/Step';
import { NotSure, OnboardingFlows } from './common';

export const targetAudiencePersonal: Step = {
    id: OnboardingFlows.TargetAudience,
    title: 'Who is your target audience?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Consumers',
        },
        {
            label: 'Businesses',
        },
        {
            label: 'Family or friends',
        },
        {
            label: NotSure,
        },
    ],
};
